import React, { useContext } from 'react'
import { Link } from 'gatsby'
import { FiMenu } from 'react-icons/fi'
import { Spinner } from '@chakra-ui/react'
import { Flex, Grid, Box } from '@chakra-ui/react'
import { useBreakpointValue } from '@chakra-ui/react'
import { Button, IconButton } from '@chakra-ui/react'

import { UserRoutes } from '~config/routes'
import AccountButton from './account-button'
import { UserContext } from '~config/user-context'
import { useClinic } from '~contexts/clinic-context'
import SharedStack from '~components/shared/wrappers/shared-stack'
import TempAlertButton from '~components/temp-alerts/temp-alert-button'
import NotFullySyncedTag from '~components/shared/tags/not-fully-synced-tag'
import AskChckvetTrigger from '~components/ask-chckvet/ask-chckvet-trigger'
import SiteSearchBar from './site-search'
import WhatsNewButton from './whats-new'

const Header: React.FC<{
    onOpenSidebar: () => void
    onOpenSearch: () => void
}> = ({ onOpenSidebar, onOpenSearch }) => {
    const { user, isLoading } = useContext(UserContext)
    const { clinic } = useClinic()
    const showHamburger = useBreakpointValue({ base: true, lg: false })

    return (
        <Box w="full" p={{ base: 0, lg: 2 }} pb={{ base: 0, lg: 0 }}>
            <Grid
                templateColumns={{
                    base: '1fr auto',
                    lg: '1fr minmax(360px, 560px) 1fr',
                }}
                gap={3}
                w="full"
                bg="white"
                boxSizing="border-box"
                position="relative"
                justifyContent="space-between"
                alignItems="center"
                rounded={{ base: 'none', lg: '2xl' }}
                borderWidth={1}
                borderColor="gray.200"
                p={2}
                shadow={{ base: 'none', lg: 'blue.lg' }}
            >
                <Flex flex={1} align="center" minW={0} gap={3}>
                    {clinic && <NotFullySyncedTag clinic={clinic} size="md" />}
                </Flex>
                {!showHamburger && (
                    <Flex justify="center" align="center" minW={0} gap={2}>
                        <WhatsNewButton />
                        <SiteSearchBar onClick={onOpenSearch} />
                    </Flex>
                )}
                <SharedStack row justify="flex-end" spacing={4}>
                    {showHamburger ? (
                        <>
                            <AskChckvetTrigger />
                            <IconButton
                                icon={<FiMenu />}
                                bg="gray.900"
                                rounded="full"
                                color="brand.400"
                                aria-label={'Menu Button'}
                                onClick={onOpenSidebar}
                            />
                        </>
                    ) : (
                        <>
                            <AskChckvetTrigger />
                            <TempAlertButton />
                            {isLoading ? (
                                <Spinner />
                            ) : user ? (
                                <AccountButton />
                            ) : (
                                <Link to={UserRoutes.Auth}>
                                    <Button>Sign in</Button>
                                </Link>
                            )}
                        </>
                    )}
                </SharedStack>
            </Grid>
        </Box>
    )
}

export default Header
